(() => {
  if (customElements.get('zb-card-gallery')) return;

  class ZbCardGallery extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      if (window.matchMedia('(max-width: 749px)').matches && this.closest('#product-grid')) {
        const cover = this.querySelector('[data-zbg-index="0"]');
        if (cover) cover.loading = 'eager';
      }
      this._images = Array.from(this.querySelectorAll('[data-zbg-image]'));
      this._dots = Array.from(this.querySelectorAll('[data-zbg-dot]'));
      this._next = this.querySelector('[data-zbg-next]');
      if (this._images.length < 2) {
        const controls = this.querySelector('[data-zbg-controls]');
        if (controls) controls.hidden = true;
        return;
      }
      this._failed = new Set();
      this._active = 0;
      this._pending = null;
      this._finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      this._select = this._select.bind(this);
      this._images.forEach((image) => {
        image.addEventListener('error', () => this._fail(image));
        if (image.dataset.zbgIndex !== '0' && image.complete && image.naturalWidth === 0) this._fail(image);
      });
      this._dots.forEach((dot, index) => dot.addEventListener('click', (event) => {
        event.stopPropagation();
        this.closest('zbh-product-carousel')?.pauseForInteraction();
        this._select(index);
      }));
      this._next?.addEventListener('click', (event) => {
        event.stopPropagation();
        this.closest('zbh-product-carousel')?.pauseForInteraction();
        this._select((this._active + 1) % this._images.length);
      });
      if (this._finePointer) {
        this.addEventListener('pointerenter', () => this._select(1));
        this.addEventListener('pointerleave', () => this._select(0));
      }
      this._select(0);
    }

    _fail(image) {
      const index = Number(image.dataset.zbgIndex);
      if (index > 0) this._failed.add(index);
      image.hidden = true;
      this._dots[index]?.setAttribute('disabled', 'disabled');
      if (this._pending === index) this._pending = null;
      if (this._active === index) this._select(0);
    }

    _select(index) {
      if (!this._images.length) return;
      const nextIndex = Math.max(0, Math.min(index, this._images.length - 1));
      if (this._failed.has(nextIndex)) return this._select((nextIndex + 1) % this._images.length);
      const image = this._images[nextIndex];
      if (nextIndex > 0 && (!image.complete || image.naturalWidth === 0)) {
        this._pending = nextIndex;
        image.loading = 'eager';
        image.addEventListener('load', () => {
          if (this._pending === nextIndex) {
            this._pending = null;
            this._select(nextIndex);
          }
        }, { once: true });
        return;
      }
      this._pending = null;
      this._active = nextIndex;
      this._images.forEach((item, itemIndex) => { item.hidden = itemIndex !== nextIndex; });
      this._dots.forEach((dot, dotIndex) => {
        const active = dotIndex === nextIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-pressed', String(active));
      });
    }
  }

  customElements.define('zb-card-gallery', ZbCardGallery);
})();
